module.exports = __webpack_public_path__ + "static/CSF3-3ae3ab1e2962a2b312741d8be831db90.png";